import styled from '@emotion/styled'
import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { Loader, VersionDisplay } from 'packages/common'
import { colors } from 'packages/styles'
import { splitSearchQuery } from 'packages/utils/misc'

import { AppContext } from 'app/fieldapp/components/core'
import { useReloadAppData } from 'app/fieldapp/utils/hooks/useReloadAppData'

import { CleanDetailDrawerContainer as CleanDetailDrawer } from '../components/CleanDetail'
import { CleansTimelineContainer } from '../components/CleansTimeline/CleanTimeline.container'
import { VisitDetailDrawerContainer } from '../components/VisitDetail/VisitDetailDrawer'
import { VisitTicketDrawerContainer } from '../components/VisitTicketDrawer'

const St = {
  SchedulePage: styled.div`
    background-color: ${colors.midnight4};
    // This is used to ensure the version is not hidden by other timers
    padding-bottom: 24px;
  `,
  VersionDisplay: styled(VersionDisplay)`
    padding-right: 8px;
  `,
}

export const SchedulePage: React.FC = () => {
  const location = useLocation()
  const history = useHistory()
  const { selectedClean = '' } = splitSearchQuery(location.search)

  const appContext = React.useContext(AppContext)

  const appIsLoading = React.useMemo(
    () => !appContext.isFullyInitialized || appContext.isRefetchingAppData,
    [appContext],
  )

  const { isLoading, onRefetchAppData } = useReloadAppData()

  /**
   * Handler for clicking on a clean card; triggers CleanDetail view for that clean
   */
  const handleCleanClick = React.useCallback(
    (cleanId: string): void => {
      history.push(`/cleans?selectedClean=${cleanId}`)
    },
    [history],
  )

  const isCleanTimeLineLoading = React.useMemo(
    () => isLoading || appIsLoading,
    [appIsLoading, isLoading],
  )

  return isCleanTimeLineLoading ? (
    <Loader />
  ) : (
    <St.SchedulePage>
      <CleansTimelineContainer
        onCleanClick={handleCleanClick}
        refetchCleans={onRefetchAppData}
      />
      <St.VersionDisplay />

      <VisitDetailDrawerContainer />
      <VisitTicketDrawerContainer />
      <CleanDetailDrawer cleanId={selectedClean} />
    </St.SchedulePage>
  )
}
